(() => {
  const selector = '[data-card-review-rating]';
  const cachePrefix = 'judgeme-card-rating:';
  let gradientId = 0;

  const parseRating = (html) => {
    const match = html.match(
      /data-average-rating=["']([\d.]+)["'][\s\S]{0,800}?data-number-of-reviews=["'](\d+)["']/i,
    );
    const rating = Number.parseFloat(match?.[1]);
    const count = Number.parseInt(match?.[2], 10);

    return Number.isFinite(rating) && Number.isFinite(count) && count > 0 ? { rating, count } : null;
  };

  const getRating = async (productUrl) => {
    const cacheKey = `${cachePrefix}${productUrl}`;

    try {
      const cached = window.sessionStorage.getItem(cacheKey);
      if (cached) return JSON.parse(cached);
    } catch (error) {
      // Continue without session storage when the browser blocks it.
    }

    const response = await fetch(productUrl, { credentials: 'same-origin' });
    if (!response.ok) return null;

    const rating = parseRating(await response.text());
    if (!rating) return null;

    try {
      window.sessionStorage.setItem(cacheKey, JSON.stringify(rating));
    } catch (error) {
      // The rating can still be rendered without caching it.
    }

    return rating;
  };

  const createStar = (fill) => {
    const namespace = 'http://www.w3.org/2000/svg';
    const id = `card-rating-gradient-${gradientId++}`;
    const star = document.createElementNS(namespace, 'svg');
    const defs = document.createElementNS(namespace, 'defs');
    const gradient = document.createElementNS(namespace, 'linearGradient');
    const filledStop = document.createElementNS(namespace, 'stop');
    const emptyStop = document.createElementNS(namespace, 'stop');
    const path = document.createElementNS(namespace, 'path');

    star.setAttribute('class', 'card__rating-star');
    star.setAttribute('viewBox', '0 0 20 20');
    star.setAttribute('focusable', 'false');
    gradient.setAttribute('id', id);
    gradient.setAttribute('x1', '0');
    gradient.setAttribute('x2', '1');
    filledStop.setAttribute('offset', `${fill}%`);
    filledStop.setAttribute('stop-color', '#f58220');
    emptyStop.setAttribute('offset', `${fill}%`);
    emptyStop.setAttribute('stop-color', '#d8d8d2');
    path.setAttribute('fill', `url(#${id})`);
    path.setAttribute('d', 'M10 1.7l2.48 5.03 5.55.81-4.02 3.92.95 5.53L10 14.36l-4.96 2.61.95-5.53-4.02-3.92 5.55-.81L10 1.7z');

    gradient.append(filledStop, emptyStop);
    defs.append(gradient);
    star.append(defs, path);
    return star;
  };

  const renderRating = (element, { rating, count }) => {
    const ratingValue = document.createElement('span');
    const stars = document.createElement('span');
    const reviewCount = document.createElement('span');

    ratingValue.className = 'card__rating-value';
    ratingValue.textContent = rating.toFixed(1);
    stars.className = 'card__rating-stars';
    stars.setAttribute('aria-hidden', 'true');
    reviewCount.className = 'card__rating-count';
    reviewCount.textContent = `(${new Intl.NumberFormat('en-US').format(count)})`;
    reviewCount.setAttribute('aria-hidden', 'true');

    for (let star = 1; star <= 5; star += 1) {
      const fill = Math.max(0, Math.min(100, (rating - (star - 1)) * 100));
      stars.append(createStar(fill));
    }

    element.setAttribute('role', 'img');
    element.setAttribute('aria-label', `${rating.toFixed(1)} out of 5 stars from ${count} reviews`);
    element.replaceChildren(ratingValue, stars, reviewCount);
    element.hidden = false;
  };

  const loadElement = async (element) => {
    if (element.dataset.cardReviewRatingState) return;
    element.dataset.cardReviewRatingState = 'loading';

    try {
      const rating = await getRating(element.dataset.productUrl);
      if (rating) renderRating(element, rating);
    } catch (error) {
      // Keep cards without accessible review data clean and unchanged.
    } finally {
      element.dataset.cardReviewRatingState = 'done';
    }
  };

  const loadRatings = (root = document) => {
    root.querySelectorAll(selector).forEach(loadElement);
  };

  document.addEventListener('DOMContentLoaded', () => {
    loadRatings();
    new MutationObserver(() => loadRatings()).observe(document.body, { childList: true, subtree: true });
  });
})();
